export enum ETheme {
  Dark = 'dark',
  Light = 'light',
}
